export default function insertNodeBefore(element, newNode) {
    return element.parentNode.insertBefore(newNode, element.nextSibling);
}
